import React from "react";

export const CreateIcon = ({
  size,
  color,
  opacity,
}) => (
  <svg
    width={size || "16"}
    height={size || "16"}
    viewBox="0 0 16 16"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8333 0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5ZM12.1667 8.83333H8.83333V12.1667H7.16667V8.83333H3.83333V7.16667H7.16667V3.83333H8.83333V7.16667H12.1667V8.83333Z"
      fill={color || "white"}
      fillOpacity={opacity || "0.4"}
    />
  </svg>
);

export const CustomCreateIcon = ({
  size,
  color,
}) => (
  <svg
  width={size || "20" }
  height={size || "20"}
  viewBox="0 0 20 20"
  fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_197_444)">
  <path
  d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM14.1667 10.8333H10.8333V14.1667H9.16667V10.8333H5.83333V9.16667H9.16667V5.83333H10.8333V9.16667H14.1667V10.8333Z"
  fill={color || "#007DBC"}/>
  </g>
  <defs>
  <clipPath id="clip0_197_444">
  <rect width="20" height="20" fill="white"/>
  </clipPath>
  </defs>
  </svg>
)

export const DeleteIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00033 13.8333C1.00033 14.75 1.75033 15.5 2.66699 15.5H9.33366C10.2503 15.5 11.0003 14.75 11.0003 13.8333V3.83333H1.00033V13.8333ZM11.8337 1.33333H8.91699L8.08366 0.5H3.91699L3.08366 1.33333H0.166992V3H11.8337V1.33333Z"
      fill="white"
      fillOpacity="1"
    />
  </svg>
);

export const DeleteIconDark = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 12 16"
    fill="#212529"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00033 13.8333C1.00033 14.75 1.75033 15.5 2.66699 15.5H9.33366C10.2503 15.5 11.0003 14.75 11.0003 13.8333V3.83333H1.00033V13.8333ZM11.8337 1.33333H8.91699L8.08366 0.5H3.91699L3.08366 1.33333H0.166992V3H11.8337V1.33333Z"
      fill="#95A4B1"
    />
  </svg>
);
export const StartIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99984 0.666504C4.39984 0.666504 0.666504 4.39984 0.666504 8.99984C0.666504 13.5998 4.39984 17.3332 8.99984 17.3332C13.5998 17.3332 17.3332 13.5998 17.3332 8.99984C17.3332 4.39984 13.5998 0.666504 8.99984 0.666504ZM7.33317 12.7498V5.24984L12.3332 8.99984L7.33317 12.7498Z"
      fill="white"
      fillOpacity="0.4"
    />
  </svg>
);
export const BuildIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1667 7.16667V0.5H3.83333V3.83333H0.5V15.5H7.16667V12.1667H8.83333V15.5H15.5V7.16667H12.1667ZM3.83333 13.8333H2.16667V12.1667H3.83333V13.8333ZM3.83333 10.5H2.16667V8.83333H3.83333V10.5ZM3.83333 7.16667H2.16667V5.5H3.83333V7.16667ZM7.16667 10.5H5.5V8.83333H7.16667V10.5ZM7.16667 7.16667H5.5V5.5H7.16667V7.16667ZM7.16667 3.83333H5.5V2.16667H7.16667V3.83333ZM10.5 10.5H8.83333V8.83333H10.5V10.5ZM10.5 7.16667H8.83333V5.5H10.5V7.16667ZM10.5 3.83333H8.83333V2.16667H10.5V3.83333ZM13.8333 13.8333H12.1667V12.1667H13.8333V13.8333ZM13.8333 10.5H12.1667V8.83333H13.8333V10.5Z"
      fill="#007DBC"
    />
  </svg>
);
export const ExpandIcon = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5025 0.333374L9 6.82171L2.4975 0.333374L0.5 2.33087L9 10.8309L17.5 2.33087L15.5025 0.333374Z"
      fill="#95A4B1"
    />
  </svg>
);
export const CollapseIcon = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4975 10.6666L9 4.17829L15.5025 10.6666L17.5 8.66913L9 0.169127L0.5 8.66913L2.4975 10.6666Z"
      fill="#95A4B1"
    />
  </svg>
);
export const MoneyIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8335 11.6663V4.99967C15.8335 4.08301 15.0835 3.33301 14.1668 3.33301H2.50016C1.5835 3.33301 0.833496 4.08301 0.833496 4.99967V11.6663C0.833496 12.583 1.5835 13.333 2.50016 13.333H14.1668C15.0835 13.333 15.8335 12.583 15.8335 11.6663ZM8.3335 10.833C6.95016 10.833 5.8335 9.71634 5.8335 8.33301C5.8335 6.94967 6.95016 5.83301 8.3335 5.83301C9.71683 5.83301 10.8335 6.94967 10.8335 8.33301C10.8335 9.71634 9.71683 10.833 8.3335 10.833ZM19.1668 5.83301V14.9997C19.1668 15.9163 18.4168 16.6663 17.5002 16.6663H3.3335V14.9997H17.5002V5.83301H19.1668Z"
      fill="#007DBC"
    />
  </svg>
);
export const SettingsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1401 10.936C17.1761 10.636 17.2001 10.324 17.2001 10C17.2001 9.67602 17.1761 9.36403 17.1281 9.06402L19.1561 7.48002C19.3361 7.33602 19.3841 7.07202 19.2761 6.86802L17.3561 3.54402C17.2361 3.32802 16.9841 3.25602 16.7681 3.32802L14.3801 4.28802C13.8761 3.90402 13.3481 3.59202 12.7601 3.35202L12.4001 0.808024C12.3641 0.568024 12.1601 0.400024 11.9201 0.400024H8.08011C7.84011 0.400024 7.64811 0.568024 7.61211 0.808024L7.25211 3.35202C6.66411 3.59202 6.12411 3.91602 5.63211 4.28802L3.24411 3.32802C3.02811 3.24402 2.77611 3.32802 2.65611 3.54402L0.736107 6.86802C0.616107 7.08402 0.664107 7.33602 0.856107 7.48002L2.88411 9.06402C2.83611 9.36403 2.80011 9.68802 2.80011 10C2.80011 10.312 2.82411 10.636 2.87211 10.936L0.844106 12.52C0.664106 12.664 0.616107 12.928 0.724107 13.132L2.64411 16.456C2.76411 16.672 3.01611 16.744 3.23211 16.672L5.62011 15.712C6.12411 16.096 6.65211 16.408 7.24011 16.648L7.60011 19.192C7.64811 19.432 7.84011 19.6 8.08011 19.6H11.9201C12.1601 19.6 12.3641 19.432 12.3881 19.192L12.7481 16.648C13.3361 16.408 13.8761 16.084 14.3681 15.712L16.7561 16.672C16.9721 16.756 17.2241 16.672 17.3441 16.456L19.2641 13.132C19.3841 12.916 19.3361 12.664 19.1441 12.52L17.1401 10.936ZM10.0001 13.6C8.02011 13.6 6.40011 11.98 6.40011 10C6.40011 8.02002 8.02011 6.40002 10.0001 6.40002C11.9801 6.40002 13.6001 8.02002 13.6001 10C13.6001 11.98 11.9801 13.6 10.0001 13.6Z"
      fill="#95A4B1"
    />
  </svg>
);
export const LinkIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.33333 0.5V1.83333H9.72667L3.17333 8.38667L4.11333 9.32667L10.6667 2.77333V5.16667H12V0.5H7.33333ZM10.6667 11.1667H1.33333V1.83333H6V0.5H1.33333C0.979711 0.5 0.640573 0.640476 0.390524 0.890524C0.140476 1.14057 0 1.47971 0 1.83333V11.1667C0 11.5203 0.140476 11.8594 0.390524 12.1095C0.640573 12.3595 0.979711 12.5 1.33333 12.5H10.6667C11.0203 12.5 11.3594 12.3595 11.6095 12.1095C11.8595 11.8594 12 11.5203 12 11.1667V6.5H10.6667V11.1667Z"
      fill="#007DBC"
    />
  </svg>
);
export const PrintIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="6" fill="#EDF3F8" />
    <path
      d="M24 9H12V13H24V9ZM25 18C24.7348 18 24.4804 17.8946 24.2929 17.7071C24.1054 17.5196 24 17.2652 24 17C24 16.7348 24.1054 16.4804 24.2929 16.2929C24.4804 16.1054 24.7348 16 25 16C25.2652 16 25.5196 16.1054 25.7071 16.2929C25.8946 16.4804 26 16.7348 26 17C26 17.2652 25.8946 17.5196 25.7071 17.7071C25.5196 17.8946 25.2652 18 25 18ZM22 25H14V20H22V25ZM25 14H11C10.2044 14 9.44129 14.3161 8.87868 14.8787C8.31607 15.4413 8 16.2044 8 17V23H12V27H24V23H28V17C28 16.2044 27.6839 15.4413 27.1213 14.8787C26.5587 14.3161 25.7956 14 25 14Z"
      fill="#007DBC"
    />
  </svg>
);
export const InactivePrintIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="6" fill="#EDF3F8" />
    <path
      d="M24 9H12V13H24V9ZM25 18C24.7348 18 24.4804 17.8946 24.2929 17.7071C24.1054 17.5196 24 17.2652 24 17C24 16.7348 24.1054 16.4804 24.2929 16.2929C24.4804 16.1054 24.7348 16 25 16C25.2652 16 25.5196 16.1054 25.7071 16.2929C25.8946 16.4804 26 16.7348 26 17C26 17.2652 25.8946 17.5196 25.7071 17.7071C25.5196 17.8946 25.2652 18 25 18ZM22 25H14V20H22V25ZM25 14H11C10.2044 14 9.44129 14.3161 8.87868 14.8787C8.31607 15.4413 8 16.2044 8 17V23H12V27H24V23H28V17C28 16.2044 27.6839 15.4413 27.1213 14.8787C26.5587 14.3161 25.7956 14 25 14Z"
      fill="#7492a1"
    />
  </svg>
);
export const RequestsIndicator = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="5" fill="#EB7575" />
  </svg>
);
export const AssignedToUser = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 3.99999H12.3334V2.33332C12.3334 1.41666 11.5834 0.666656 10.6667 0.666656H7.33335C6.41669 0.666656 5.66669 1.41666 5.66669 2.33332V3.99999H2.33335C1.41669 3.99999 0.666687 4.74999 0.666687 5.66666V14.8333C0.666687 15.75 1.41669 16.5 2.33335 16.5H15.6667C16.5834 16.5 17.3334 15.75 17.3334 14.8333V5.66666C17.3334 4.74999 16.5834 3.99999 15.6667 3.99999ZM5.16669 11.0833C4.66669 11.0833 4.33335 10.75 4.33335 10.25C4.33335 9.74999 4.66669 9.41666 5.16669 9.41666C5.66669 9.41666 6.00002 9.74999 6.00002 10.25C6.00002 10.75 5.66669 11.0833 5.16669 11.0833ZM9.00002 11.0833C8.50002 11.0833 8.16669 10.75 8.16669 10.25C8.16669 9.74999 8.50002 9.41666 9.00002 9.41666C9.50002 9.41666 9.83335 9.74999 9.83335 10.25C9.83335 10.75 9.50002 11.0833 9.00002 11.0833ZM10.6667 3.99999H7.33335V2.33332H10.6667V3.99999ZM12.8334 11.0833C12.3334 11.0833 12 10.75 12 10.25C12 9.74999 12.3334 9.41666 12.8334 9.41666C13.3334 9.41666 13.6667 9.74999 13.6667 10.25C13.6667 10.75 13.25 11.0833 12.8334 11.0833Z"
      fill="#0099E7"
    />
  </svg>
);
export const ActiveIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 3.99999H12.3334V2.33332C12.3334 1.40832 11.5917 0.666656 10.6667 0.666656H7.33335C6.40835 0.666656 5.66669 1.40832 5.66669 2.33332V3.99999H2.33335C1.40835 3.99999 0.67502 4.74166 0.67502 5.66666L0.666687 14.8333C0.666687 15.7583 1.40835 16.5 2.33335 16.5H15.6667C16.5917 16.5 17.3334 15.7583 17.3334 14.8333V5.66666C17.3334 4.74166 16.5917 3.99999 15.6667 3.99999ZM10.6667 3.99999H7.33335V2.33332H10.6667V3.99999Z"
      fill="#0099E7"
    />
  </svg>
);
export const DraftIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      d="M15.6665 4.00033H12.3332V2.33366C12.3332 1.40866 11.5915 0.666992 10.6665 0.666992H7.33317C6.40817 0.666992 5.6665 1.40866 5.6665 2.33366V4.00033H2.33317C1.40817 4.00033 0.674837 4.74199 0.674837 5.66699L0.666504 14.8337C0.666504 15.7587 1.40817 16.5003 2.33317 16.5003H15.6665C16.5915 16.5003 17.3332 15.7587 17.3332 14.8337V5.66699C17.3332 4.74199 16.5915 4.00033 15.6665 4.00033ZM10.6665 4.00033H7.33317V2.33366H10.6665V4.00033Z"
      fill="#95A4B1"
    />
  </svg>
);
export const Completed = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 3.99999H12.3334V2.33332C12.3334 1.41666 11.5834 0.666656 10.6667 0.666656H7.33335C6.41669 0.666656 5.66669 1.41666 5.66669 2.33332V3.99999H2.33335C1.41669 3.99999 0.666687 4.74999 0.666687 5.66666V14.8333C0.666687 15.75 1.41669 16.5 2.33335 16.5H15.6667C16.5834 16.5 17.3334 15.75 17.3334 14.8333V5.66666C17.3334 4.74999 16.5834 3.99999 15.6667 3.99999ZM7.33335 2.33332H10.6667V3.99999H7.33335V2.33332ZM7.75002 13.5833L4.83335 10.75L5.83335 9.74999L7.66669 11.5833L12.4167 6.83332L13.4167 7.83332L7.75002 13.5833Z"
      fill="#0099E7"
    />
  </svg>
);
export const QuestionMarkIcon = ({color}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill={color || "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00033 0.666748C4.40033 0.666748 0.666992 4.40008 0.666992 9.00008C0.666992 13.6001 4.40033 17.3334 9.00033 17.3334C13.6003 17.3334 17.3337 13.6001 17.3337 9.00008C17.3337 4.40008 13.6003 0.666748 9.00033 0.666748ZM9.83366 14.8334H8.16699V13.1667H9.83366V14.8334ZM11.5587 8.37508L10.8087 9.14175C10.2087 9.75008 9.83366 10.2501 9.83366 11.5001H8.16699V11.0834C8.16699 10.1667 8.54199 9.33342 9.14199 8.72508L10.1753 7.67508C10.4837 7.37508 10.667 6.95842 10.667 6.50008C10.667 5.58342 9.91699 4.83342 9.00033 4.83342C8.08366 4.83342 7.33366 5.58342 7.33366 6.50008H5.66699C5.66699 4.65841 7.15866 3.16675 9.00033 3.16675C10.842 3.16675 12.3337 4.65841 12.3337 6.50008C12.3337 7.23342 12.0337 7.90008 11.5587 8.37508Z"
      fill={color || "#0099E7"}
    />
  </svg>
);
export const CalendarIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 8.16663H3.83333V9.83329H5.5V8.16663ZM8.83333 8.16663H7.16667V9.83329H8.83333V8.16663ZM12.1667 8.16663H10.5V9.83329H12.1667V8.16663ZM13.8333 2.33329H13V0.666626H11.3333V2.33329H4.66667V0.666626H3V2.33329H2.16667C1.24167 2.33329 0.508333 3.08329 0.508333 3.99996L0.5 15.6666C0.5 16.1087 0.675595 16.5326 0.988155 16.8451C1.30072 17.1577 1.72464 17.3333 2.16667 17.3333H13.8333C14.75 17.3333 15.5 16.5833 15.5 15.6666V3.99996C15.5 3.08329 14.75 2.33329 13.8333 2.33329ZM13.8333 15.6666H2.16667V6.49996H13.8333V15.6666Z"
      fill="#007DBC"
    />
  </svg>
);
export const CreateCalendarIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 448 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M96 32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32zM448 464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192H448V464zM200 272V328H144C130.7 328 120 338.7 120 352C120 365.3 130.7 376 144 376H200V432C200 445.3 210.7 456 224 456C237.3 456 248 445.3 248 432V376H304C317.3 376 328 365.3 328 352C328 338.7 317.3 328 304 328H248V272C248 258.7 237.3 248 224 248C210.7 248 200 258.7 200 272z"
      fill="#007DBC"
    />
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99935 0.666626C4.40435 0.666626 0.666016 4.40496 0.666016 8.99996C0.666016 13.595 4.40435 17.3333 8.99935 17.3333C13.5943 17.3333 17.3327 13.595 17.3327 8.99996C17.3327 4.40496 13.5943 0.666626 8.99935 0.666626ZM11.7435 12.9225L8.16602 9.34496V3.99996H9.83268V8.65496L12.9219 11.7441L11.7435 12.9225Z"
      fill="#007DBC"
    />
  </svg>
);
export const PoundIcon = () => (
  <svg
    color="#007DBC"
    width="18"
    height="16"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="pound-sign"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
  >
    <path
      fill="currentColor"
      d="M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ></path>
  </svg>
);
export const UserIcon = () => (
  <svg
    color="#007DBC"
    width="18"
    height="16"
    aria-hidden="true"
    focusable="false"
    data-prefix="fas"
    data-icon="user"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ></path>
  </svg>
);
export const EditIcon = ({color = "#95A4B1"}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.625 17.5938H1.375C0.960156 17.5938 0.625 17.9289 0.625 18.3438V19.1875C0.625 19.2906 0.709375 19.375 0.8125 19.375H19.1875C19.2906 19.375 19.375 19.2906 19.375 19.1875V18.3438C19.375 17.9289 19.0398 17.5938 18.625 17.5938ZM4.03984 15.625C4.08672 15.625 4.13359 15.6203 4.18047 15.6133L8.12266 14.9219C8.16953 14.9125 8.21406 14.8914 8.24688 14.8563L18.182 4.92109C18.2038 4.89941 18.221 4.87366 18.2328 4.8453C18.2445 4.81695 18.2506 4.78656 18.2506 4.75586C18.2506 4.72516 18.2445 4.69477 18.2328 4.66642C18.221 4.63806 18.2038 4.61231 18.182 4.59063L14.2867 0.692969C14.2422 0.648438 14.1836 0.625 14.1203 0.625C14.057 0.625 13.9984 0.648438 13.9539 0.692969L4.01875 10.6281C3.98359 10.6633 3.9625 10.7055 3.95312 10.7523L3.26172 14.6945C3.23892 14.8201 3.24707 14.9493 3.28545 15.071C3.32384 15.1927 3.39132 15.3032 3.48203 15.393C3.63672 15.543 3.83125 15.625 4.03984 15.625Z"
      fill={color}
    />
  </svg>
);

export const FlatOptionsIcon = () => (
  <svg
    width="4"
    height="16"
    viewBox="0 0 4 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
      fill="#95A4B1"
    />
  </svg>
);

export const SortOrderIcon = ({size = 24}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 11L12 8L15 11H9Z" fill="#95A4B1" />
    <path d="M15 13L12 16L9 13L15 13Z" fill="#95A4B1" />
  </svg>
);

export const CameraIcon = ({color="#95a4b1"}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill={color}
    />
    <path
      d="M20 4H16.83L15.59 2.65C15.4036 2.44539 15.1767 2.28191 14.9235 2.16999C14.6704 2.05807 14.3968 2.00017 14.12 2H9.88C9.32 2 8.78 2.24 8.4 2.65L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
      fill={color}
    />
  </svg>
);


export const CommentIcon = ({color="#95a4b1"}) => (
    <svg
        width="24"
        height="24"
        viewBox="0 -960 960 960"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z"
            fill={color}/>
    </svg>
);

export const TemplatesIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V3C14 3.26522 13.8946 3.51957 13.7071 3.70711C13.5196 3.89464 13.2652 4 13 4H1C0.734784 4 0.48043 3.89464 0.292893 3.70711C0.105357 3.51957 0 3.26522 0 3V1Z"
      fill="#95A4B1"
    />
    <path
      d="M0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289C0.48043 6.10536 0.734784 6 1 6H7C7.26522 6 7.51957 6.10536 7.70711 6.29289C7.89464 6.48043 8 6.73478 8 7V13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14H1C0.734784 14 0.48043 13.8946 0.292893 13.7071C0.105357 13.5196 0 13.2652 0 13V7Z"
      fill="#95A4B1"
    />
    <path
      d="M11 6C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7V13C10 13.2652 10.1054 13.5196 10.2929 13.7071C10.4804 13.8946 10.7348 14 11 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V7C14 6.73478 13.8946 6.48043 13.7071 6.29289C13.5196 6.10536 13.2652 6 13 6H11Z"
      fill="#95A4B1"
    />
  </svg>
);

export const VATIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16L3.5 14L7 16L10.5 14L14 16V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0H2ZM4.5 3C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5C3 4.89782 3.15804 5.27936 3.43934 5.56066C3.72064 5.84196 4.10218 6 4.5 6C4.89782 6 5.27936 5.84196 5.56066 5.56066C5.84196 5.27936 6 4.89782 6 4.5C6 4.10218 5.84196 3.72064 5.56066 3.43934C5.27936 3.15804 4.89782 3 4.5 3ZM10.707 3.293C10.5195 3.10553 10.2652 3.00021 10 3.00021C9.73484 3.00021 9.48053 3.10553 9.293 3.293L3.293 9.293C3.19749 9.38525 3.12131 9.49559 3.0689 9.6176C3.01649 9.7396 2.9889 9.87082 2.98775 10.0036C2.9866 10.1364 3.0119 10.2681 3.06218 10.391C3.11246 10.5139 3.18671 10.6255 3.2806 10.7194C3.3745 10.8133 3.48615 10.8875 3.60905 10.9378C3.73194 10.9881 3.86362 11.0134 3.9964 11.0123C4.12918 11.0111 4.2604 10.9835 4.3824 10.9311C4.50441 10.8787 4.61475 10.8025 4.707 10.707L10.707 4.707C10.8945 4.51947 10.9998 4.26516 10.9998 4C10.9998 3.73484 10.8945 3.48053 10.707 3.293ZM9.5 8C9.10218 8 8.72064 8.15804 8.43934 8.43934C8.15804 8.72064 8 9.10218 8 9.5C8 9.89782 8.15804 10.2794 8.43934 10.5607C8.72064 10.842 9.10218 11 9.5 11C9.89782 11 10.2794 10.842 10.5607 10.5607C10.842 10.2794 11 9.89782 11 9.5C11 9.10218 10.842 8.72064 10.5607 8.43934C10.2794 8.15804 9.89782 8 9.5 8Z"
      fill="#95A4B1"
    />
  </svg>
);

export const FolderIcon = () => (
  <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 16C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H8L10 2H18C18.55 2 19.021 2.196 19.413 2.588C19.8043 2.97933 20 3.45 20 4V14C20 14.55 19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H2Z" fill="#FEAE36"/>
  </svg>
)

export const InvoicesIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 384 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M384 128h-128V0L384 128zM256 160H384v304c0 26.51-21.49 48-48 48h-288C21.49 512 0 490.5 0 464v-416C0 21.49 21.49 0 48 0H224l.0039 128C224 145.7 238.3 160 256 160zM64 88C64 92.38 67.63 96 72 96h80C156.4 96 160 92.38 160 88v-16C160 67.63 156.4 64 152 64h-80C67.63 64 64 67.63 64 72V88zM72 160h80C156.4 160 160 156.4 160 152v-16C160 131.6 156.4 128 152 128h-80C67.63 128 64 131.6 64 136v16C64 156.4 67.63 160 72 160zM197.5 316.8L191.1 315.2C168.3 308.2 168.8 304.1 169.6 300.5c1.375-7.812 16.59-9.719 30.27-7.625c5.594 .8438 11.73 2.812 17.59 4.844c10.39 3.594 21.83-1.938 25.45-12.34c3.625-10.44-1.891-21.84-12.33-25.47c-7.219-2.484-13.11-4.078-18.56-5.273V248c0-11.03-8.953-20-20-20s-20 8.969-20 20v5.992C149.6 258.8 133.8 272.8 130.2 293.7c-7.406 42.84 33.19 54.75 50.52 59.84l5.812 1.688c29.28 8.375 28.8 11.19 27.92 16.28c-1.375 7.812-16.59 9.75-30.31 7.625c-6.938-1.031-15.81-4.219-23.66-7.031l-4.469-1.625c-10.41-3.594-21.83 1.812-25.52 12.22c-3.672 10.41 1.781 21.84 12.2 25.53l4.266 1.5c7.758 2.789 16.38 5.59 25.06 7.512V424c0 11.03 8.953 20 20 20s20-8.969 20-20v-6.254c22.36-4.793 38.21-18.53 41.83-39.43C261.3 335 219.8 323.1 197.5 316.8z"
      fill="#95A4B1"
    />
  </svg>
);

export const QAStepsIcon = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8333 12.567V8.16699L16.3333 5.66699L13 2.33366L10.5 4.83366H4.66667V4.00033H7.16667V0.666992H0.5V4.00033H3V9.00033H0.5V12.3337H3V16.5003H6.56667C6.71209 16.7522 6.92091 16.9617 7.17236 17.1079C7.42381 17.2541 7.70914 17.3319 8 17.3337C8.29298 17.3354 8.58125 17.2599 8.83575 17.1148C9.09025 16.9696 9.30199 16.7599 9.44962 16.5069C9.59726 16.2538 9.67558 15.9663 9.67668 15.6733C9.67778 15.3803 9.60163 15.0922 9.45591 14.838C9.31018 14.5839 9.10003 14.3726 8.84663 14.2255C8.59323 14.0785 8.30554 14.0008 8.01256 14.0004C7.71957 13.9999 7.43165 14.0767 7.1778 14.223C6.92396 14.3693 6.71316 14.5799 6.56667 14.8337H4.66667V12.3337H7.16667V9.00033H4.66667V6.50033H10.5L12.1667 8.16699V12.5587C11.8489 12.7421 11.6006 13.0253 11.4602 13.3642C11.3198 13.7032 11.2952 14.079 11.3901 14.4334C11.4851 14.7878 11.6943 15.1009 11.9854 15.3243C12.2765 15.5476 12.6331 15.6687 13 15.6687C13.3669 15.6687 13.7235 15.5476 14.0146 15.3243C14.3057 15.1009 14.5149 14.7878 14.6099 14.4334C14.7048 14.079 14.6802 13.7032 14.5398 13.3642C14.3994 13.0253 14.1511 12.7421 13.8333 12.5587V12.567ZM1.33333 3.16699V1.50033H6.33333V3.16699H1.33333ZM8 14.8337C8.16482 14.8337 8.32593 14.8825 8.46298 14.9741C8.60002 15.0657 8.70683 15.1958 8.7699 15.3481C8.83297 15.5004 8.84948 15.6679 8.81732 15.8296C8.78517 15.9912 8.7058 16.1397 8.58926 16.2562C8.47271 16.3728 8.32423 16.4522 8.16258 16.4843C8.00092 16.5165 7.83337 16.5 7.6811 16.4369C7.52883 16.3738 7.39868 16.267 7.30711 16.13C7.21554 15.9929 7.16667 15.8318 7.16667 15.667C7.16667 15.446 7.25446 15.234 7.41074 15.0777C7.56703 14.9215 7.77899 14.8337 8 14.8337ZM6.33333 9.83366V11.5003H1.33333V9.83366H6.33333ZM13 3.50866L15.1583 5.66699L13 7.82533L10.8417 5.66699L13 3.50866ZM13 14.8337C12.8352 14.8337 12.6741 14.7848 12.537 14.6932C12.4 14.6016 12.2932 14.4715 12.2301 14.3192C12.167 14.167 12.1505 13.9994 12.1827 13.8377C12.2148 13.6761 12.2942 13.5276 12.4107 13.4111C12.5273 13.2945 12.6758 13.2152 12.8374 13.183C12.9991 13.1508 13.1666 13.1674 13.3189 13.2304C13.4712 13.2935 13.6013 13.4003 13.6929 13.5373C13.7845 13.6744 13.8333 13.8355 13.8333 14.0003C13.8333 14.2213 13.7455 14.4333 13.5893 14.5896C13.433 14.7459 13.221 14.8337 13 14.8337Z"
      fill="#95A4B1"
    />
  </svg>
);

export const OperativeStepsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.625 0C0.79076 0 0.949732 0.065848 1.06694 0.183058C1.18415 0.300269 1.25 0.45924 1.25 0.625V19.375C1.25 19.5408 1.18415 19.6997 1.06694 19.8169C0.949732 19.9342 0.79076 20 0.625 20C0.45924 20 0.300269 19.9342 0.183058 19.8169C0.065848 19.6997 0 19.5408 0 19.375V0.625C0 0.45924 0.065848 0.300269 0.183058 0.183058C0.300269 0.065848 0.45924 0 0.625 0V0ZM2.5 1.875C2.5 1.70924 2.56585 1.55027 2.68306 1.43306C2.80027 1.31585 2.95924 1.25 3.125 1.25H8.125C8.29076 1.25 8.44973 1.31585 8.56694 1.43306C8.68415 1.55027 8.75 1.70924 8.75 1.875V3.125C8.75 3.29076 8.68415 3.44973 8.56694 3.56694C8.44973 3.68415 8.29076 3.75 8.125 3.75H3.125C2.95924 3.75 2.80027 3.68415 2.68306 3.56694C2.56585 3.44973 2.5 3.29076 2.5 3.125V1.875ZM5 6.875C5 6.70924 5.06585 6.55027 5.18306 6.43306C5.30027 6.31585 5.45924 6.25 5.625 6.25H14.375C14.5408 6.25 14.6997 6.31585 14.8169 6.43306C14.9342 6.55027 15 6.70924 15 6.875V8.125C15 8.29076 14.9342 8.44973 14.8169 8.56694C14.6997 8.68415 14.5408 8.75 14.375 8.75H5.625C5.45924 8.75 5.30027 8.68415 5.18306 8.56694C5.06585 8.44973 5 8.29076 5 8.125V6.875ZM7.5 11.875C7.5 11.7092 7.56585 11.5503 7.68306 11.4331C7.80027 11.3158 7.95924 11.25 8.125 11.25H15.625C15.7908 11.25 15.9497 11.3158 16.0669 11.4331C16.1842 11.5503 16.25 11.7092 16.25 11.875V13.125C16.25 13.2908 16.1842 13.4497 16.0669 13.5669C15.9497 13.6842 15.7908 13.75 15.625 13.75H8.125C7.95924 13.75 7.80027 13.6842 7.68306 13.5669C7.56585 13.4497 7.5 13.2908 7.5 13.125V11.875ZM10 16.875C10 16.7092 10.0658 16.5503 10.1831 16.4331C10.3003 16.3158 10.4592 16.25 10.625 16.25H19.375C19.5408 16.25 19.6997 16.3158 19.8169 16.4331C19.9342 16.5503 20 16.7092 20 16.875V18.125C20 18.2908 19.9342 18.4497 19.8169 18.5669C19.6997 18.6842 19.5408 18.75 19.375 18.75H10.625C10.4592 18.75 10.3003 18.6842 10.1831 18.5669C10.0658 18.4497 10 18.2908 10 18.125V16.875Z"
      fill="#95A4B1"
    />
  </svg>
);

export const JobTemplatesIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6665 4.00033H12.3332V2.33366C12.3332 1.40866 11.5915 0.666992 10.6665 0.666992H7.33317C6.40817 0.666992 5.6665 1.40866 5.6665 2.33366V4.00033H2.33317C1.40817 4.00033 0.674837 4.74199 0.674837 5.66699L0.666504 14.8337C0.666504 15.7587 1.40817 16.5003 2.33317 16.5003H15.6665C16.5915 16.5003 17.3332 15.7587 17.3332 14.8337V5.66699C17.3332 4.74199 16.5915 4.00033 15.6665 4.00033ZM10.6665 4.00033H7.33317V2.33366H10.6665V4.00033Z"
      fill="#95A4B1"
    />
  </svg>
);

export const ResetIcon = ({color="white"}) => (
  <svg
  width="16"
  height="16"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 576 512">
  <path
  d="M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
  fill={color}
  />
  </svg>
)

export const EditMoneyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.75 5.25H2.25C1.85218 5.25 1.47064 5.40804 1.18934 5.68934C0.908035 5.97064 0.75 6.35218 0.75 6.75V17.25C0.75 17.6478 0.908035 18.0294 1.18934 18.3107C1.47064 18.592 1.85218 18.75 2.25 18.75H21.75C22.1478 18.75 22.5294 18.592 22.8107 18.3107C23.092 18.0294 23.25 17.6478 23.25 17.25V6.75C23.25 6.35218 23.092 5.97064 22.8107 5.68934C22.5294 5.40804 22.1478 5.25 21.75 5.25ZM7.03125 17.25L2.25 13.1531V10.8469L7.03125 6.75H16.9688L21.75 10.8469V13.1531L16.9688 17.25H7.03125ZM15.75 12C15.75 12.7417 15.5301 13.4667 15.118 14.0834C14.706 14.7001 14.1203 15.1807 13.4351 15.4645C12.7498 15.7484 11.9958 15.8226 11.2684 15.6779C10.541 15.5333 9.8728 15.1761 9.34835 14.6517C8.8239 14.1272 8.46675 13.459 8.32205 12.7316C8.17736 12.0042 8.25162 11.2502 8.53545 10.5649C8.81928 9.87971 9.29993 9.29404 9.91661 8.88199C10.5333 8.46993 11.2583 8.25 12 8.25C12.9946 8.25 13.9484 8.64509 14.6517 9.34835C15.3549 10.0516 15.75 11.0054 15.75 12Z" fill="#007DBC"/>
  <path d="M29.0417 18.7187L27.2708 16.9687L27.8542 16.3853C28.0139 16.2256 28.2101 16.1458 28.4429 16.1458C28.6754 16.1458 28.8715 16.2256 29.0312 16.3853L29.6146 16.9687C29.7743 17.1284 29.8576 17.3212 29.8646 17.547C29.8715 17.7726 29.7951 17.9652 29.6354 18.1249L29.0417 18.7187ZM22.6667 23.7499C22.5486 23.7499 22.4497 23.7099 22.37 23.6299C22.29 23.5502 22.25 23.4513 22.25 23.3333V22.1562C22.25 22.1006 22.2604 22.0469 22.2813 21.9949C22.3021 21.9427 22.3333 21.8958 22.375 21.8541L26.6667 17.5624L28.4375 19.3333L24.1458 23.6249C24.1042 23.6666 24.0574 23.6978 24.0054 23.7187C23.9532 23.7395 23.8993 23.7499 23.8437 23.7499H22.6667Z" fill="#007DBC"/>
  </svg>
)

export  const BriefCaseQuestionMarkIcon = () => (
<svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.4258 10.3401C16.9808 10.3401 14.1848 13.2589 14.1848 16.8553C14.1848 20.4516 16.9808 23.3704 20.4258 23.3704C23.8708 23.3704 26.6667 20.4516 26.6667 16.8553C26.6667 13.2589 23.8708 10.3401 20.4258 10.3401ZM21.0499 21.4159H19.8017V20.1128H21.0499V21.4159ZM22.3418 16.3666L21.7801 16.966C21.3307 17.4416 21.0499 17.8325 21.0499 18.8098H19.8017V18.4841C19.8017 17.7674 20.0825 17.1159 20.5319 16.6403L21.3058 15.8193C21.5367 15.5848 21.674 15.259 21.674 14.9007C21.674 14.184 21.1123 13.5977 20.4258 13.5977C19.7393 13.5977 19.1776 14.184 19.1776 14.9007H17.9294C17.9294 13.4609 19.0465 12.2946 20.4258 12.2946C21.805 12.2946 22.9222 13.4609 22.9222 14.9007C22.9222 15.474 22.6975 15.9953 22.3418 16.3666Z" fill="#007DBC"/>
<path d="M13.3735 4.2454H10.996V3.00441C10.996 2.32187 10.461 1.76343 9.80721 1.76343H7.4297C6.77589 1.76343 6.24095 2.32187 6.24095 3.00441V4.2454H3.86344C3.20962 4.2454 2.67468 4.80384 2.67468 5.48638V12.3118C2.67468 12.9943 3.20962 13.5528 3.86344 13.5528H13.3735C14.0273 13.5528 14.5622 12.9943 14.5622 12.3118V5.48638C14.5622 4.80384 14.0273 4.2454 13.3735 4.2454ZM5.88432 9.51958C5.5277 9.51958 5.28994 9.27139 5.28994 8.89909C5.28994 8.5268 5.5277 8.2786 5.88432 8.2786C6.24095 8.2786 6.4787 8.5268 6.4787 8.89909C6.4787 9.27139 6.24095 9.51958 5.88432 9.51958ZM8.61846 9.51958C8.26183 9.51958 8.02408 9.27139 8.02408 8.89909C8.02408 8.5268 8.26183 8.2786 8.61846 8.2786C8.97509 8.2786 9.21284 8.5268 9.21284 8.89909C9.21284 9.27139 8.97509 9.51958 8.61846 9.51958ZM9.80721 4.2454H7.4297V3.00441H9.80721V4.2454ZM11.3526 9.51958C10.996 9.51958 10.7582 9.27139 10.7582 8.89909C10.7582 8.5268 10.996 8.2786 11.3526 8.2786C11.7092 8.2786 11.947 8.5268 11.947 8.89909C11.947 9.27139 11.6498 9.51958 11.3526 9.51958Z" fill="#007DBC"/>
</svg>
)

export const InfoIcon = ({size, color}) => (
<svg
width={size || "19"}
height={size || "19"}
viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.55 14.25H10.45V8.55H8.55V14.25ZM9.5 6.65C9.76917 6.65 9.99495 6.5588 10.1774 6.3764C10.3591 6.19463 10.45 5.96917 10.45 5.7C10.45 5.43083 10.3591 5.20505 10.1774 5.02265C9.99495 4.84088 9.76917 4.75 9.5 4.75C9.23083 4.75 9.00537 4.84088 8.8236 5.02265C8.6412 5.20505 8.55 5.43083 8.55 5.7C8.55 5.96917 8.6412 6.19463 8.8236 6.3764C9.00537 6.5588 9.23083 6.65 9.5 6.65ZM9.5 19C8.18583 19 6.95083 18.7505 5.795 18.2514C4.63917 17.753 3.63375 17.0763 2.77875 16.2213C1.92375 15.3663 1.24703 14.3608 0.7486 13.205C0.249533 12.0492 0 10.8142 0 9.5C0 8.18583 0.249533 6.95083 0.7486 5.795C1.24703 4.63917 1.92375 3.63375 2.77875 2.77875C3.63375 1.92375 4.63917 1.24672 5.795 0.74765C6.95083 0.249217 8.18583 0 9.5 0C10.8142 0 12.0492 0.249217 13.205 0.74765C14.3608 1.24672 15.3663 1.92375 16.2213 2.77875C17.0763 3.63375 17.753 4.63917 18.2514 5.795C18.7505 6.95083 19 8.18583 19 9.5C19 10.8142 18.7505 12.0492 18.2514 13.205C17.753 14.3608 17.0763 15.3663 16.2213 16.2213C15.3663 17.0763 14.3608 17.753 13.205 18.2514C12.0492 18.7505 10.8142 19 9.5 19Z"
fill={color || "#95A4B1"}/>
</svg>
)
